import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  CategoryType,
  ClientDocumentType,
  DocumentStatus,
  TagType,
} from 'api/Documents/Types/ClientDocument'
import { DocumentStatusReasonDto } from 'api/Documents/Types/DocumentStatusReasonDto'

const initialState: DocumentState = {
  documentType: [],
  documentTypesByCategory: {},
  categoryType: [],
  statuses: [],
  tag: [],
  statusReasons: [],
}

export interface DocumentState {
  documentType: ClientDocumentType[]
  documentTypesByCategory: Record<string | number, ClientDocumentType[]>
  categoryType: CategoryType[]
  statuses: DocumentStatus[]
  tag: TagType[]
  statusReasons: DocumentStatusReasonDto[]
}

export const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    fetchDocumentTypes: (state, action: PayloadAction<ClientDocumentType[]>) => {
      state.documentType = action.payload
    },
    fetchDocumentTypesByCategory: (
      state,
      action: PayloadAction<{ categoryId: string | number; types: ClientDocumentType[] }>
    ) => {
      state.documentTypesByCategory[action.payload.categoryId] = action.payload.types
    },
    fetchDocumentCategoryType: (state, action: PayloadAction<CategoryType[]>) => {
      state.categoryType = action.payload
    },
    fetchDocumentStatusesType: (state, action: PayloadAction<DocumentStatus[]>) => {
      state.statuses = action.payload
    },
    fetchDocumentTagType: (state, action: PayloadAction<TagType[]>) => {
      state.tag = action.payload
    },
    fetchDocumentStatusReasons: (state, action: PayloadAction<DocumentStatusReasonDto[]>) => {
      state.statusReasons = action.payload
    },
  },
})
